import { render, staticRenderFns } from "./formulaList.vue?vue&type=template&id=6d5e5b5c&scoped=true&"
import script from "./formulaList.vue?vue&type=script&lang=js&"
export * from "./formulaList.vue?vue&type=script&lang=js&"
import style0 from "./formulaList.vue?vue&type=style&index=0&id=6d5e5b5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5e5b5c",
  null
  
)

export default component.exports